import React from "react";
import { useFormContext } from "react-hook-form";
import { UploadFilesForm } from "../../../UploadFiles";
import { Grid, Typography } from "@mui/material";
import { FileIcon, defaultStyles, DefaultExtensionType } from "react-file-icon";

export default function UploadFilesList() {
  const { getValues } = useFormContext<UploadFilesForm>();
  const { files } = getValues();

  return files?.length ? (
    <Grid item sx={{ padding: "16px 0" }}>
      <Typography variant={"subtitle2"} gutterBottom>
        Файлы для загрузки
      </Typography>
      {Array.from(files).map((file) => {
        const ext = file.name.split(".").pop() as DefaultExtensionType;

        return (
          <Grid key={file.name} container alignItems={"center"}>
            <Grid item sx={{ maxWidth: "24px" }}>
              <FileIcon extension={ext} {...defaultStyles[ext]} />
            </Grid>
            <Grid item sx={{ paddingLeft: "16px" }}>
              {file.name}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  ) : null;
}
